import React from 'react';
import { FormGroup, Radio } from 'react-bootstrap';

import LocationInput from 'components/LocationInput/LocationInput';

import styles from './PostRemote.module.scss';

const PostRemote = ({
  onChangeRemote,
  locationSelected,
  remoteSelected,
  onChangeLocation,
}) => (
  <form className={styles.form} id="post-brief-remote">
    <p className="fs-15 lato-bold">Is the freelancer required onsite?</p>
    <FormGroup>
      <div style={{ border: '1px solid #ddd', borderRadius: '4px' }}>
        <div className="fs-15" style={{ borderTop: 0, padding: '10px' }}>
          <Radio
            className={styles.radio}
            id="post-brief-work-remotely"
            onChange={() => onChangeRemote(true)}
            checked={remoteSelected}
          >
            No, we can work online
          </Radio>
        </div>
        <div
          className="fs-15"
          style={{ borderTop: '1px solid #ddd', padding: '10px' }}
        >
          <Radio
            className={styles.radio}
            id="post-brief-work-local"
            onChange={() => onChangeRemote(false)}
            checked={!remoteSelected}
          >
            Yes, they need to be at a location
          </Radio>
        </div>
      </div>
      {!remoteSelected && (
        <div>
          <hr />
          <p className="mt fs-15 mb lato-bold">
            Where do they need to be based?
          </p>
          <LocationInput
            id="post-remote-location-input"
            style={{ width: '350px' }}
            placeholder="Enter a city or country"
            shouldClearOnBlur={!locationSelected}
            onChangePlace={(location) => onChangeLocation(location)}
            googleAPIType="regions"
          />
        </div>
      )}
    </FormGroup>
  </form>
);

export default PostRemote;
